/* eslint-disable react/prop-types */
/** @jsx React.createElement */
/** @jsxFrag React.Fragment */

import { autocomplete } from "@algolia/autocomplete-js";
import React, { createElement, Fragment, useEffect, useRef } from "react";
import { render } from "react-dom";

const Autocomplete = ({ props }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) {
      return undefined;
    }

    const search = autocomplete({
      container: containerRef.current,
      renderer: { createElement, Fragment, render },
      ...props,
    });

    return () => {
      search.destroy();
    };
  }, [props?.plugins]);

  return <div ref={containerRef} />;
};

export default Autocomplete;
